import { ApplePayAction, ApplePayActionType } from '../actions/applePay';
import { ApplePayNameSpace } from '../state/applePay';

export const applepayReducer = (
    state: ApplePayNameSpace = {
        applepayPaymentRequest: null,
        applepayInstance: null,
        canMakePaymentsWithActiveCard: false,
        isLoadingApplePay: false,
    },
    action: ApplePayAction,
): ApplePayNameSpace => {
    switch (action.type) {
        case ApplePayActionType.setApplepayPaymentRequest:
        case ApplePayActionType.setApplepayInstance:
        case ApplePayActionType.setCanMakePaymentsWithActiveCard:
        case ApplePayActionType.setIsLoadingApplePay:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
